import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGentooComponent } from './simple-icons-gentoo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGentooComponent ],
    exports:      [ SimpleIconsGentooComponent ],
    bootstrap:    []
})
export class SimpleIconsGentooModule {}
